// extracted by mini-css-extract-plugin
export default {"journalPage":"styles_journalPage__KX-Nw","left":"styles_left__YB5Se","right":"styles_right__X0Ap5","line":"styles_line__RZMGa"};